module.exports = __webpack_public_path__ + "static/media/mobBell.75723226.svg";